import React from 'react';

function ResilincLegendList({ legends: itemsList }) {
    const hasData = itemsList && itemsList.length > 0;

    return (
        <div className='legend-list' style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: "center" }}>
            {hasData ? itemsList.map((item, idx) => {
                const isSpecial = item.name === 'PepsiCo Site';
                return (
                    <div key={`resilinc-${idx}`} className='legend-item' style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                        <svg xmlns="www.w3.org" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            {isSpecial ? (
                                <rect width={12} height={12} fill={item.color} />
                            ) : (
                                <circle cx={6} cy={6} r={6} fill={item.color} />
                            )}
                        </svg>
                        <span className='legend-title' style={{ marginLeft: '5px', width: "100%" }}>
                            {item.name}
                        </span>
                    </div>
                );
            }) : null} 
        </div>
    );
}

export default ResilincLegendList;
